import { IScheduledJob } from "@kuika/kuika-cl-model";
import * as React from "react";
import { KuikaListTableRowAction } from "../../ui-kit/kuika-list-table/kuika-list-table";
import KuikaSvg from "../../ui-kit/kuika-svg/kuika-svg";

/**
 * What can be done to a job from a list of jobs: the landing table's row menu and the editor
 * switcher's "…" are this one list, so the two cannot offer different things.
 */

export const isScheduledJobActive = (job: IScheduledJob): boolean => !!job.json?.isActive;

export interface IScheduledJobRowActionHandlers {
  onToggleActive: (job: IScheduledJob) => void;
  /** Opens the host's confirmation; nothing is deleted until it is answered. */
  onRequestDelete: (job: IScheduledJob) => void;
}

export const buildScheduledJobRowActions = (
  handlers: IScheduledJobRowActionHandlers
): KuikaListTableRowAction<IScheduledJob>[] => [
  {
    key: "activate",
    label: "Activate",
    icon: <KuikaSvg width={16} height={16} name="player-play" />,
    hidden: (row: IScheduledJob) => isScheduledJobActive(row),
    onSelect: handlers.onToggleActive
  },
  {
    key: "inactivate",
    label: "Inactivate",
    icon: <KuikaSvg width={16} height={16} name="player-pause" />,
    hidden: (row: IScheduledJob) => !isScheduledJobActive(row),
    onSelect: handlers.onToggleActive
  },
  {
    key: "delete",
    label: "Delete",
    icon: <KuikaSvg width={16} height={16} name="trash" />,
    danger: true,
    onSelect: handlers.onRequestDelete
  }
];
